var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsCounter4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8124 3.22915L40.7915 0H9.18753L9.14587 3.22915H0V15.2396C0 16.1146 0.218754 16.9688 0.635424 17.7396L2.04172 20.3021C2.83339 21.75 4.2084 22.8021 5.8126 23.1979C6.28135 23.3125 6.76052 23.375 7.23965 23.375C8.07299 23.375 8.90633 23.1979 9.67719 22.8542L23.3335 35.6666V39.7395L12.6248 46.7708C12.0102 47.177 11.729 47.9375 11.9373 48.6458C12.1456 49.3542 12.7915 49.8438 13.531 49.8438L37.6979 50H37.7083C38.4479 50 39.1041 49.4896 39.3125 48.7709C39.5209 48.0521 39.2187 47.2605 38.5729 46.875L26.6662 39.6147V35.6667L40.2291 22.8124C41.0208 23.1874 41.8854 23.3749 42.7603 23.3749C43.2395 23.3749 43.7186 23.3124 44.1874 23.1978C45.7916 22.802 47.1562 21.7396 47.9583 20.302L49.3646 17.7395C49.7812 16.9791 50 16.1146 50 15.2395V3.22905L40.8124 3.22915ZM6.61406 19.9692C5.90573 19.7921 5.31196 19.3442 4.96825 18.6983L3.56195 16.1358C3.41612 15.865 3.33279 15.5525 3.33279 15.2504V6.56288H9.10368L8.94743 18.74L8.35368 19.7921C7.81201 20.0526 7.20788 20.115 6.61406 19.9692ZM19.0722 46.5216L25.1035 42.5633L31.7181 46.5945L19.0722 46.5216ZM24.9889 32.6568L12.2489 20.6987L12.478 3.33391H37.4782L37.6136 20.6987L24.9889 32.6568ZM46.6662 15.2396C46.6662 15.5521 46.5829 15.8542 46.4371 16.1251L45.0308 18.6875C44.6766 19.3334 44.0933 19.7813 43.3849 19.9584C42.7912 20.1042 42.187 20.0417 41.6453 19.7917L40.937 18.5105L40.8328 6.56286H46.6662V15.2396Z",
    fill: "#00BAB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsCounter4);
export default __webpack_public_path__ + "static/media/about-us-counter-4.fac27b33ae8742d7d381523d7ff7fe21.svg";
export { ForwardRef as ReactComponent };